import { useState } from 'react';

const pilares = [
  {
    id: 1,
    icon: 'ri-graduation-cap-line',
    titulo: 'Formación Técnica Especializada',
    resumen: 'Capacitamos a personas en habilidades técnicas demandadas por el mercado laboral actual.',
    descripcion:
      'Desarrollamos programas de formación técnica en áreas estratégicas con alta demanda laboral en la región. Nuestros cursos están diseñados junto a empresas del sector privado para garantizar que los participantes adquieran competencias reales y aplicables de inmediato en el entorno de trabajo.',
    color: 'from-[#2D7AA6] to-[#1a5a80]',
    bgLight: 'bg-[#EBF5FB]',
    textColor: 'text-[#2D7AA6]',
    stats: '500+ personas formadas',
  },
  {
    id: 2,
    icon: 'ri-briefcase-line',
    titulo: 'Programas de Pasantías Laborales',
    resumen: 'Conectamos a jóvenes talentos con empresas para adquirir experiencia práctica real.',
    descripcion:
      'Facilitamos oportunidades de pasantías en empresas aliadas del Valle de Sula, permitiendo que los participantes apliquen sus conocimientos en entornos laborales reales. Este programa fortalece el vínculo entre la formación académica y las necesidades del sector productivo, generando una transición efectiva hacia el empleo formal.',
    color: 'from-[#1a7a5e] to-[#0f5a44]',
    bgLight: 'bg-[#E8F8F5]',
    textColor: 'text-[#1a7a5e]',
    stats: '200+ pasantías gestionadas',
  },
  {
    id: 3,
    icon: 'ri-exchange-line',
    titulo: 'Intermediación Laboral',
    resumen: 'Vinculamos a buscadores de empleo con empresas privadas de manera eficiente y transparente.',
    descripcion:
      'Actuamos como puente entre personas en búsqueda de empleo y las empresas privadas que requieren talento humano calificado. A través de un proceso de perfilamiento, orientación vocacional y vinculación directa, logramos colocaciones laborales exitosas que benefician tanto a los trabajadores como a las organizaciones empleadoras.',
    color: 'from-[#7a4a1a] to-[#5a3410]',
    bgLight: 'bg-[#FEF5E7]',
    textColor: 'text-[#7a4a1a]',
    stats: '350+ colocaciones exitosas',
  },
];

const manuales = [
  {
    id: 1,
    nombre: 'Manual de Usuario — Buscador de Empleo',
    descripcion: 'Guía paso a paso para registrarte y usar la plataforma como candidato.',
    icon: 'ri-user-line',
    url: 'https://1drv.ms/b/c/fb19e4b8c9152241/IQD_MWgAm6HfTZVowc_kG5JNAaB1lughf_C9bGzZYwIHJZw?e=3fuUz2',
  },
  {
    id: 2,
    nombre: 'Manual de Usuario — Empresa Empleadora',
    descripcion: 'Instrucciones para publicar vacantes y gestionar candidatos en la plataforma.',
    icon: 'ri-building-line',
    url: 'https://1drv.ms/b/c/fb19e4b8c9152241/IQA8Hm3iCGXYTIQmypAyCAxuARWRLXC7Tf98Nr0kcY0Dn5s?e=i22Gnr',
  },
];

export default function Empleabilidad() {
  const [pilarActivo, setPilarActivo] = useState(1);

  const pilarSeleccionado = pilares.find((p) => p.id === pilarActivo)!;

  return (
    <section id="empleabilidad" className="py-28 bg-[#F4F8FB]">
      <div className="max-w-7xl mx-auto px-8 lg:px-16">

        {/* Encabezado */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-[#2D7AA6]/10 text-[#2D7AA6] text-sm font-semibold rounded-full mb-4 tracking-wide uppercase">
            Servicios de Empleabilidad
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-5 leading-tight">
            Conectamos Talento con <br />
            <span className="text-[#2D7AA6]">Oportunidades Reales</span>
          </h2>
          <p className="text-lg text-gray-500 max-w-2xl mx-auto leading-relaxed">
            El CDE trabaja activamente para reducir el desempleo en el Valle de Sula mediante
            programas integrales que forman, orientan y vinculan a las personas con el mercado laboral.
          </p>
        </div>

        {/* Tabs de pilares */}
        <div className="flex flex-wrap justify-center gap-3 mb-10">
          {pilares.map((p) => (
            <button
              key={p.id}
              onClick={() => setPilarActivo(p.id)}
              className={`flex items-center gap-2 px-5 py-3 rounded-full font-medium text-sm transition-all duration-300 whitespace-nowrap cursor-pointer border ${
                pilarActivo === p.id
                  ? `bg-gradient-to-r ${p.color} text-white shadow-lg border-transparent`
                  : 'bg-white text-gray-600 border-gray-200 hover:border-[#2D7AA6] hover:text-[#2D7AA6]'
              }`}
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${p.icon} text-base`}></i>
              </div>
              {p.titulo}
            </button>
          ))}
        </div>

        {/* Panel del pilar activo */}
        <div className="grid lg:grid-cols-2 gap-10 items-center mb-16">
          <div
            key={pilarSeleccionado.id}
            className="bg-white rounded-2xl p-10 shadow-md border border-gray-100 transition-all duration-300"
          >
            <div className={`w-14 h-14 flex items-center justify-center rounded-xl ${pilarSeleccionado.bgLight} mb-6`}>
              <i className={`${pilarSeleccionado.icon} text-2xl ${pilarSeleccionado.textColor}`}></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">{pilarSeleccionado.titulo}</h3>
            <p className="text-gray-600 leading-relaxed mb-6">{pilarSeleccionado.descripcion}</p>
          </div>

          {/* Imagen ilustrativa */}
          <div className="relative rounded-2xl overflow-hidden h-80 shadow-lg">
            <img
              src={
                pilarActivo === 1
                  ? 'https://static.readdy.ai/image/099135a1a0137decf986b79a09f23af6/bd4a036da438f92ffaedd242f1b982d3.jpeg'
                  : pilarActivo === 2
                  ? 'https://static.readdy.ai/image/099135a1a0137decf986b79a09f23af6/06c0ace62f696f969eb0d5e67476f159.jpeg'
                  : 'https://static.readdy.ai/image/099135a1a0137decf986b79a09f23af6/341fd0811f1e57038c91bda0352841ff.jpeg'
              }
              alt={pilarSeleccionado.titulo}
              className="w-full h-full object-cover object-top transition-all duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
            <div className="absolute bottom-5 left-5 right-5">
              <p className="text-white font-semibold text-lg drop-shadow">{pilarSeleccionado.resumen}</p>
            </div>
          </div>
        </div>

        {/* Plataforma de empleo + Manuales */}
        <div className="bg-gradient-to-br from-[#2D7AA6] to-[#1a5a80] rounded-2xl p-10 shadow-xl">
          <div className="grid lg:grid-cols-2 gap-10 items-start">

            {/* CTA Plataforma */}
            <div>
              <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-xl mb-5">
                <i className="ri-computer-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-white mb-3">Plataforma de Empleo - Mi Contact</h3>
              <p className="text-white/80 leading-relaxed mb-6">
                Accede a nuestra plataforma exclusiva de empleo donde buscadores de trabajo y empresas
                se conectan de forma directa, rápida y segura. Publica tu perfil, explora vacantes
                disponibles y da el siguiente paso en tu carrera profesional.
              </p>
              <a
                href="https://empleo.micontact.org/"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="inline-flex items-center gap-2 bg-white text-[#2D7AA6] px-7 py-3.5 rounded-xl font-semibold hover:bg-gray-100 transition-all duration-300 shadow-md whitespace-nowrap cursor-pointer"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-external-link-line text-base"></i>
                </div>
                Ir a Mi Contact
              </a>
            </div>

            {/* Manuales descargables */}
            <div>
              <div className="flex items-center gap-2 mb-5">
                <div className="w-8 h-8 flex items-center justify-center bg-white/20 rounded-lg">
                  <i className="ri-file-download-line text-white text-lg"></i>
                </div>
                <h4 className="text-white font-bold text-lg">Manuales de Uso</h4>
              </div>
              <div className="space-y-4">
                {manuales.map((manual) => (
                  <div
                    key={manual.id}
                    className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-5 flex items-start gap-4"
                  >
                    <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-lg flex-shrink-0">
                      <i className={`${manual.icon} text-white text-lg`}></i>
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-white font-semibold text-sm mb-1">{manual.nombre}</p>
                      <p className="text-white/70 text-xs mb-3">{manual.descripcion}</p>
                      <a
                        href={manual.url}
                        target="_blank"
                        rel="noopener noreferrer nofollow"
                        className="inline-flex items-center gap-1.5 bg-white/20 hover:bg-white/30 text-white text-xs font-medium px-3 py-1.5 rounded-lg cursor-pointer transition-all whitespace-nowrap"
                      >
                        <div className="w-4 h-4 flex items-center justify-center">
                          <i className="ri-download-line text-xs"></i>
                        </div>
                        Descargar manual (PDF)
                      </a>
                    </div>
                  </div>
                ))}
              </div>
              <p className="text-white/50 text-xs mt-4 flex items-center gap-1">
                <i className="ri-information-line"></i>
                Haz clic en el botón para descargar el manual correspondiente.
              </p>
            </div>

          </div>
        </div>

      </div>
    </section>
  );
}
